<template>
  <v-menu bottom offset-y>
    <template #activator="{on,attrs}">
      <v-btn class="white--text" v-bind="attrs" v-on="on" text>
        <v-icon left>mdi-translate</v-icon>
        {{ locale.text }}
        <v-icon right>mdi-chevron-down</v-icon>
      </v-btn>
    </template>
    <template>
      <v-list>
        <v-list-item
          v-for="(language, i) in languages"
          :key="i"
          @click="locale = language"
        >
          <v-list-item-title v-text="language.text"></v-list-item-title>
        </v-list-item>
      </v-list>
    </template>
  </v-menu>
</template>

<script>
export default {
  name: "LangSelect",
  data() {
    return {
      languages: [
        { text: "Svenska", value: "sv" },
        { text: "English", value: "en" },
        { text: "العربية", value: "ar" }
      ]
    };
  },
  computed: {
    locale: {
      get() {
        return this.$store.getters.GET_LOCALE;
      },
      set(val) {
	
        this.$store.commit("SET_LOCALE", val);
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
